import projection from '../generated/pwg208f1.json';
import { AcceptanceManifest } from '../types';

export const pwg208f1AcceptanceManifest = projection as AcceptanceManifest;
